var __jsx = React.createElement;
import React from 'react';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Modal from '@spa/shared/components/Modal';
import { capitalizeFirstLetter } from '@spa/shared/utils/stringManipulation';
import { Text, Actions, GlobalModalStyle } from './styles';
import Button from '@spa/shared/components/Unisystem/Button';
var GenderRestrictionModal = function GenderRestrictionModal(_ref) {
  var genderRestriction = _ref.genderRestriction,
    onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useRouter = useRouter(),
    locale = _useRouter.locale,
    query = _useRouter.query,
    asPath = _useRouter.asPath;
  var acceptedGender = genderRestriction === 'males' ? 'female' : 'male';
  var title = t("".concat(capitalizeFirstLetter(acceptedGender), " tenants only"));
  var message = [t("This listing is for ".concat(acceptedGender, " tenants only.")),
  // eslint-disable-next-line prettier/prettier
  t('You can\'t send a booking request, but you can still view the listing or return to the search results.')].join(' ');
  var handleBackToSearchResults = function handleBackToSearchResults() {
    var languagePath = locale === 'en' ? '' : "".concat(locale, "/");
    var basePath = asPath.replace("/accommodation/".concat(query.city, "/").concat(query.offerId), "accommodation/".concat(query.city));
    window.location.href = "".concat(process.env.APP_URL).concat(languagePath).concat(basePath);
  };
  return __jsx(Modal, {
    onClose: onClose,
    title: title,
    className: 'gender-restriction'
  }, __jsx(GlobalModalStyle, null), __jsx(Text, null, message), __jsx(Actions, null, __jsx(Button, {
    isPrimary: true,
    onClick: handleBackToSearchResults
  }, t('Back to search results')), __jsx(Button, {
    isSecondary: true,
    onClick: onClose
  }, t('View listing anyway'))));
};
export default GenderRestrictionModal;